<template>
  <div class="book-cover-recognition" style="padding: 20px;">
    <h2>书籍封面识别</h2>
    
    <!-- 图片上传区域 -->
    <el-upload
      class="upload-demo"
      action="#"
      :auto-upload="false"
      :on-change="handleImageChange"
      :show-file-list="true"
      accept="image/*"
      :limit="1"
    >
      <el-button type="primary">选择书籍封面</el-button>
      <template #tip>
        <div class="el-upload__tip">
          请上传书籍封面图片，系统将自动识别书名、作者和出版社信息
        </div>
      </template>
    </el-upload>
    
    <!-- 预览图片 -->
    <div v-if="imageUrl" class="image-preview">
      <img :src="imageUrl" alt="书籍封面" style="max-width: 200px; max-height: 300px; margin: 10px 0;">
    </div>
    
    <!-- 识别按钮 -->
    <el-button 
      type="success" 
      @click="recognizeImage" 
      :disabled="!imageUrl"
      style="margin: 20px 0;">
      识别书籍信息
    </el-button>
    
    <!-- 识别结果 -->
    <el-form :model="bookInfo" label-width="100px" v-show="recognitionComplete">
      <el-form-item label="书名">
        <el-input v-model="bookInfo.name"></el-input>
      </el-form-item>
      <el-form-item label="作者">
        <el-input v-model="bookInfo.author"></el-input>
      </el-form-item>
      <el-form-item label="出版社">
        <el-input v-model="bookInfo.publisher"></el-input>
      </el-form-item>
      <el-form-item label="价格">
        <el-input v-model="bookInfo.price" type="number"></el-input>
      </el-form-item>
      <el-form-item label="出版时间">
        <el-date-picker
          v-model="bookInfo.createTime"
          type="date"
          value-format="YYYY-MM-DD"
          placeholder="选择出版日期"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="ISBN">
        <el-input v-model="bookInfo.isbn"></el-input>
      </el-form-item>
      
      <!-- 提交按钮 -->
      <el-form-item>
        <el-button type="primary" @click="submitBookInfo">提交书籍信息</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import request from "../utils/request";
import { ElMessage } from "element-plus";

export default {
  name: "BookCoverRecognition",
  data() {
    return {
      imageUrl: '',
      file: null,
      bookInfo: {
        name: '',
        author: '',
        publisher: '',
        price: '',
        createTime: '',
        isbn: '',
        borrownum: 0,
        status: 1
      },
      recognitionComplete: false
    };
  },
  created() {
    // 检查用户权限，只有管理员可以访问
    let userStr = sessionStorage.getItem("user") || "{}";
    let user = JSON.parse(userStr);
    if (!user.role || user.role !== 1) {
      ElMessage.error("您没有权限访问此页面");
      this.$router.push("/dashboard");
    }
  },
  methods: {
    // 处理图片上传
    handleImageChange(file) {
      this.file = file.raw;
      this.imageUrl = URL.createObjectURL(file.raw);
      this.recognitionComplete = false;
    },
    
    // 识别图片
    recognizeImage() {
      if (!this.file) {
        ElMessage.warning("请先上传书籍封面");
        return;
      }
      
      // 创建FormData对象
      let formData = new FormData();
      formData.append('file', this.file);
      
      ElMessage.info("正在识别书籍信息...");
      
      // 发送图片到后端进行识别
      request.post("/book/recognize", formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        timeout:30000
      }).then(res => {
        console.log("后端返回的完整数据:", res);
        console.log("res.code:", res.code);
        console.log("res.code类型:", typeof res.code);
        if (res.code === '0' || res.code === 0) {
          // 将后端返回的识别结果填充到表单中
          console.log("识别结果:", res.data);
          this.bookInfo = {
            name: res.data.name || "",
            author: res.data.author || "",
            publisher: res.data.publisher || "",
            price: "",
            createTime: "",
            isbn: res.data.isbn || "",
            borrownum: 0,
            status: 1
          };
          console.log("填充后的表单数据:", this.bookInfo);
          // 直接设置recognitionComplete为true
          console.log("设置recognitionComplete为true前:", this.recognitionComplete);
          this.recognitionComplete = true;
          console.log("设置recognitionComplete为true后:", this.recognitionComplete);
          // 强制Vue更新DOM
          this.$forceUpdate();
          console.log("强制更新DOM后recognitionComplete:", this.recognitionComplete);
          ElMessage.success("识别完成");
        } else {
          console.log("识别失败:", res.msg);
          ElMessage.error(res.msg || "识别失败");
        }
      }).catch(err => {
        console.error("识别错误:", err);
        // 显示更详细的错误信息
        if (err.response) {
          // 服务器返回了错误响应
          console.log("错误响应:", err.response);
          console.log("状态码:", err.response.status);
          console.log("错误数据:", err.response.data);
          ElMessage.error(`识别失败: ${err.response.status} - ${err.response.data?.msg || err.response.statusText}`);
        } else if (err.request) {
          // 请求已发送但没有收到响应
          console.log("请求已发送但没有收到响应:", err.request);
          ElMessage.error("识别失败: 服务器没有响应，请检查后端服务是否正常运行");
        } else {
          // 请求配置出错
          console.log("请求配置出错:", err.message);
          ElMessage.error(`识别失败: ${err.message}`);
        }
      });
    },
    
    // 提交书籍信息
    submitBookInfo() {
      // 验证表单
      if (!this.bookInfo.name) {
        ElMessage.warning("请输入书名");
        return;
      }
      
      // 提交数据到后端
      request.post("/book", this.bookInfo).then(res => {
        if (res.code === '0' || res.code === 0) {
          ElMessage.success("书籍信息提交成功");
          // 重置表单
          this.imageUrl = '';
          this.file = null;
          this.bookInfo = {
            name: '',
            author: '',
            publisher: '',
            price: '',
            createTime: '',
            isbn: '',
            borrownum: 0,
            status: 1
          };
          this.recognitionComplete = false;
        } else {
          ElMessage.error(res.msg);
        }
      }).catch(err => {
        ElMessage.error("提交失败，请重试");
      });
    }
  }
};
</script>

<style scoped>
.book-cover-recognition {
  max-width: 800px;
  margin: 0 auto;
}

.image-preview {
  margin: 20px 0;
}
</style>